import { fetchCached } from '@/shared/lib/useCachedQuery';
import { getConversationSettings } from '../api/userApi';
import type { ConversationSettings } from './types';

/**
 * Ключ кеша `GET /me/settings`. Один на чат (`ChatScreen`) и «Персонализацию»;
 * `SettingsPage`, интересы и онбординг сбрасывают его после `PATCH`, смена
 * языка — вместе со всем кешем.
 */
export const CONVERSATION_SETTINGS_CACHE_KEY = 'me/settings';

export function loadConversationSettings(): Promise<ConversationSettings> {
  return fetchCached(CONVERSATION_SETTINGS_CACHE_KEY, () => getConversationSettings());
}
